import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";

export const cancelApiIntergration = async (mutation, id) => {
  let status = true;
  let message = "";

  try {
    const res = request(BASEURL, mutation, {
      id: id,
    });
    
  } catch (err) {}

  return { status, message };
};
